import { data, useParams } from "react-router-dom";
import PlayerList from "../../Components/PlayerList/PlayerList";
import { useEffect, useState } from "react";
import PlayerRequests from "../../../../../Services/Api/PlayerRequests.ts";
import CategoryList from "../../Components/CategoryList/CategoryList.js";
import { IoPerson } from "react-icons/io5";
import { IoLogoGameControllerB } from "react-icons/io";
import { FaServer } from "react-icons/fa";
import RequestData from "./Categories/RequestData/RequestData.js";
import RoleManagement from "./Categories/RoleManagement/RoleManagement.js";
import Inventory from "./Categories/Inventory/Inventory.js";
import StatusEffects from "./Categories/StatusEffects/StatusEffects.js";
import Moderation from "./Categories/Moderation/Moderation.js";
import Administration from "./Categories/Administration/Administration.js";
import Broadcasting from "./Categories/Broadcasting/Broadcasting.js";
import RoundEvents from "./Categories/RoundEvents/RoundEvents.js";
import MapControl from "./Categories/MapControl/MapControl.js";
import Cassie from "./Categories/Cassie/Cassie.js";
import Console from "./Categories/Console/Console.js";
import "./RemoteAdmin.css";
import StaffChat from "./Categories/StaffChat/StaffChat.js";
import { CheckPermission } from "../../../../../Services/Permissions/PermissionManager.js";
import ScpPermissions from "../../../../../Services/Permissions/Data/ScpPermissions.js";
import { GetCurrentUser } from "../../../../../Services/Authorization/AuthorizationManager.js";

const RemoteAdmin = ({GetServer}) =>
{
    const playerRequests = new PlayerRequests();

    const { serverId } = useParams();

    const [groupedPlayers, setGroupedPlayers] = useState(null);
    const [selectedPlayers, setSelectedPlayers] = useState([]);

    const changePlayerSelection = (data) => {
        setSelectedPlayers(data);
        setRefresh(new Date().toISOString())
    }

    const [selectedCategory, setSelectedCategory] = useState(-1);
    const [, setRefresh] = useState("")
    
    const getOnlineSelectedPlayers = () => {
        return groupedPlayers[0].players.filter(x => selectedPlayers.map(y => y.userId).includes(x.userId));
    }
    const getOfflineSelectedPlayers = () => {
        return groupedPlayers[1].players.filter(x => selectedPlayers.map(y => y.userId).includes(x.userId));
    }
    const getSelectedPlayers = () => {
        const allPlayers = groupedPlayers[0].players.concat(groupedPlayers[1].players);
        
        return allPlayers.filter(x => selectedPlayers.map(y => y.userId).includes(x.userId));
    }
    const getPlayerIds = () => {
        let data = "";

        selectedPlayers.forEach(player => 
        {
            if(groupedPlayers[0].players.some(p => p.userId == player.userId))
                data += player.inGameId + ".";
        });
       
        return data;
    }

    useEffect(() => {
        refreshPlayers();

        const playerInterval = setInterval(() => {
            refreshPlayers();
        }, [5000])

        return () => { clearInterval(playerInterval) }
    }, [serverId])

    const refreshPlayers = () => {
        playerRequests.GetAll(serverId, (res) => setGroupedPlayers(
        [
            {name: "Players", players: res.users}, 
            {name: "Players Who Left", players: res.usersWhoLeft}
        ]));
    }

    if(!groupedPlayers)
        return (<></>)

    const user = GetCurrentUser();

    const checkPermission = (permissions) => {
        return !CheckPermission(GetServer(serverId)?.permissions, user.Permissions, permissions, true)
    }
    
    const groupedCategories = [
        { 
            title: <div>Player</div>,
            icon: <IoPerson />,
            color: 'rgb(255, 112, 112)',
            hoverColor: 'rgba(255, 112, 112, 0.5)',
            selectedColor: 'rgba(255, 112, 112, 0.65)',
            buttons: [
                { text: "Request data", index: 0, disabled: checkPermission([ScpPermissions.SCP_UserData]) },
                { text: "Role management", index: 1, disabled: checkPermission([ScpPermissions.SCP_RoleManagement]) },
                { text: "Inventory", index: 2, disabled: checkPermission([ScpPermissions.SCP_Inventory]) },
                { text: "Status effects", index: 3, disabled: checkPermission([ScpPermissions.SCP_StatusEffects]) },
            ]
        },
        { 
            title: <div>Server</div>,
            icon: <IoLogoGameControllerB />,
            color: 'rgb(255, 247, 129)',
            hoverColor: 'rgba(255, 247, 129, 0.5)',
            selectedColor: 'rgba(255, 247, 129, 0.65)',
            buttons: [
                { text: "Moderation", index: 4, disabled: checkPermission([ScpPermissions.SCP_Ban, ScpPermissions.SCP_Kick, ScpPermissions.SCP_Mutes]) },
                { text: "Administration", index: 5, disabled: checkPermission([ScpPermissions.SCP_Administration]) },
                { text: "Broadcasting", index: 6, disabled: checkPermission([ScpPermissions.SCP_Broadcasting]) },
                { text: "Staff Chat", index: 7, disabled: checkPermission([ScpPermissions.SCP_StaffChat]) },
            ]
        },
        { 
            title: <div>Game</div>,
            icon: <FaServer />,
            color: 'rgb(76, 255, 85)',
            hoverColor: 'rgba(76, 255, 85, 0.5)',
            selectedColor: 'rgba(76, 255, 85, 0.65)',
            buttons: [
                { text: "Round & Events", index: 8, disabled: checkPermission([ScpPermissions.SCP_RoundEvents]) },
                { text: "Map control", index: 9, disabled: checkPermission([ScpPermissions.SCP_MapControl]) },
                { text: "C.A.S.S.I.E", index: 10, disabled: checkPermission([ScpPermissions.SCP_Cassie]) },
            ]
        },
        { 
            color: 'rgb(162, 209, 224)',
            hoverColor: 'rgba(162, 209, 224, 0.5)',
            selectedColor: 'rgba(162, 209, 224, 0.65)',
            buttons: [
                { text: "Console", index: 11 },
            ]
        }
    ]

    return(
        <div class="card center-y panelFull !pl-1.5">
            <div className="w-full h-full flex">
                <PlayerList groupedPlayers={groupedPlayers} setSelectedPlayers={changePlayerSelection} selectedPlayers={selectedPlayers}/>
                <div className="flex-1 m-4">
                    { selectedCategory == 0 &&
                        <RequestData getSelectedPlayers={getSelectedPlayers}/>
                    }
                    { selectedCategory == 1 &&
                        <RoleManagement serverId={serverId} getPlayerIds={getPlayerIds} />
                    }
                    { selectedCategory == 2 &&
                        <Inventory serverId={serverId} getPlayerIds={getPlayerIds} />
                    }
                    { selectedCategory == 3 &&
                        <StatusEffects serverId={serverId} getPlayerIds={getPlayerIds} />
                    }
                    { selectedCategory == 4 &&
                        <Moderation serverId={serverId} getPlayerIds={getPlayerIds} getOnlinePlayers={getOnlineSelectedPlayers} getOfflinePlayers={getOfflineSelectedPlayers}/>
                    }
                    { selectedCategory == 5 &&
                        <Administration serverId={serverId} getPlayerIds={getPlayerIds} />
                    }
                    { selectedCategory == 6 &&
                        <Broadcasting serverId={serverId} getPlayerIds={getPlayerIds} />
                    }
                    { selectedCategory == 7 &&
                        <StaffChat serverId={serverId} getPlayerIds={getPlayerIds} />
                    }    
                    { selectedCategory == 8 &&
                        <RoundEvents serverId={serverId}/>
                    }            
                    { selectedCategory == 9 &&
                        <MapControl serverId={serverId}/>
                    }     
                    { selectedCategory == 10 &&
                        <Cassie serverId={serverId} />
                    }    
                    { selectedCategory == 11 &&
                        <Console serverId={serverId}/>
                    }           
                </div>
                <CategoryList 
                    groupedCategories={groupedCategories} 
                    selected={selectedCategory} 
                    setSelected={setSelectedCategory}
                />
            </div>
        </div>
    )
}

export default RemoteAdmin;